import { render, staticRenderFns } from "./IdentifyDocument.vue?vue&type=template&id=ff2528de"
import script from "./IdentifyDocument.vue?vue&type=script&lang=js"
export * from "./IdentifyDocument.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports